var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4429_12913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 14.6668L13.333 13.3335M7.66634 14.0002C8.49805 14.0002 9.32161 13.8363 10.09 13.5181C10.8584 13.1998 11.5566 12.7333 12.1447 12.1452C12.7328 11.5571 13.1993 10.8589 13.5176 10.0905C13.8359 9.3221 13.9997 8.49853 13.9997 7.66683C13.9997 6.83512 13.8359 6.01156 13.5176 5.24317C13.1993 4.47477 12.7328 3.77659 12.1447 3.18849C11.5566 2.60038 10.8584 2.13387 10.09 1.81559C9.32161 1.49731 8.49805 1.3335 7.66634 1.3335C5.98664 1.3335 4.37573 2.00076 3.188 3.18849C2.00027 4.37622 1.33301 5.98712 1.33301 7.66683C1.33301 9.34653 2.00027 10.9574 3.188 12.1452C4.37573 13.3329 5.98664 14.0002 7.66634 14.0002Z",
    stroke: "#7E7E80",
    strokeWidth: 1.09091,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4429_12913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search.f8a92b4b.svg";
export { ForwardRef as ReactComponent };